import {FC} from 'react';

export const CodeBlock: FC<{children: string; maxHeight?: number}> = ({children, maxHeight = 280}) => (
  <pre
    className="overflow-auto rounded-md border border-[#ebecf0] bg-[#fbfbfc] p-3 font-mono text-[11.5px] leading-relaxed text-[#33364b]"
    style={{maxHeight}}>
    {children}
  </pre>
);
